import { render, staticRenderFns } from "./FeedbackListItem.vue?vue&type=template&id=77c6b779&"
import script from "./FeedbackListItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports